// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2373":"7fc89e97003a72f1","9961":"c1e35734739bc181"}[chunkId] + ".css";
};